<template>
    <div class="chart-container">
        <canvas ref="lineChart" />
    </div>
</template>

<script setup>
import {defineProps, ref, onMounted, onBeforeUnmount, watch} from 'vue';
import {Chart, registerables} from 'chart.js';

Chart.register(...registerables);

const props = defineProps({
    chartData: {
        type: Object,
        required: true,
    },
    chartOptions: {
        type: Object,
        required: true,
    },
});

const lineChart = ref(null);
let chartInstance = null;

onMounted(() => {
    const ctx = lineChart.value.getContext('2d');
    chartInstance = new Chart(ctx, {
        type: 'line',
        data: props.chartData,
        options: props.chartOptions,
    });
});

onBeforeUnmount(() => {
    if (chartInstance) {
        chartInstance.destroy();
    }
});

// 监听 chartData 的变化
watch(() => props.chartData, (newData, oldData) => {
    if (chartInstance) {
        chartInstance.data = newData;
        chartInstance.update();
    }
}, {deep: true});

// 监听 title 的变化
watch(() => props.chartOptions, (newData, oldData) => {
    if (chartInstance) {
        chartInstance.options = newData;
        chartInstance.update();
    }
}, {deep: true});

</script>

<style scoped>
.chart-container {
  position: relative;
  height: 100%;
  width: 100%;
}
</style>
